export default "__VITE_ASSET__CezKjnF1__"